
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study-abroad-online-counselling",
      function () {
        return require("private-next-pages/study-abroad-online-counselling.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study-abroad-online-counselling"])
      });
    }
  